// src/components/ProtectedRoute.tsx
import { FC, useEffect, useState } from "react";
import { IoArrowBack } from "react-icons/io5";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import LanguageMenu from "./LanguageMenu";
import OverlayLoading from "./OverlayLoading";

const QuoteLayout: FC<{
  isShow: boolean;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ isShow, setIsShow }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setViewportHeight();

    window.addEventListener("resize", setViewportHeight);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", setViewportHeight);
  }, []);

  useEffect(() => {
    const handleGlobalLogin = (e: any) => {
      setIsLoading(e.detail?.value?.toString() === "true");
    };

    window.addEventListener("globalLoading", handleGlobalLogin);

    return () => window.removeEventListener("globalLoading", handleGlobalLogin);
  }, []);

  return (
    <div className="flex flex-col items-stretch justify-center min-h-screen px-4 py-4">
      <OverlayLoading isLoading={isLoading} />
      <div className="container flex items-center justify-center mx-auto">
        <div className="w-10">
          {isShow && !searchParams.get("quoteId") && (
            <IoArrowBack
              className="absolute cursor-pointer top-5 left-4"
              size={25}
              onClick={() => {
                setIsShow(false);
              }}
            />
          )}
        </div>
        {!isShow && (
          <>
            <div className="flex items-center justify-center flex-1">
              <img
                src="/image/logo.png"
                className="cursor-pointer w-44"
                onClick={() => navigate("/")}
              />
            </div>
            <div className="w-10">
              <LanguageMenu />
            </div>
          </>
        )}
      </div>

      <div className="container flex flex-col items-stretch flex-grow mx-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default QuoteLayout;
